import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/components/ScalarIcon/icons/Leave.svg?component
var Leave_exports = /* @__PURE__ */ __exportAll({
	default: () => Leave_default,
	render: () => render$1
});
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	"stroke-linecap": "round",
	"stroke-linejoin": "round",
	viewBox: "0 0 24 24"
};
function render$1(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", { d: "M16.35 16.5v1c0 1.1-.9 2-2 2H2.75c-1.1 0-2-.9-2-2v-11c0-1.1.9-2 2-2h11.6c1.1 0 2 .9 2 2v1M5.25 12h18m0 0-3 3.1m3-3.1-3-2.9" }, null, -1)])]);
}
var Leave_default = { render: render$1 };
//#endregion
export { Leave_exports, Leave_default as default, render$1 as render };

//# sourceMappingURL=Leave.svg_component.js.map